<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>{{ $t('managementOrders.title') }}</h6>
          <p class="font13 gray-col">
            {{ $t('managementOrders.subtitle') }}
          </p>
        </div>
      </div>
      <div class="manage-account-tabs">
        <ul class="nav nav-tabs mb-3" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active"
              id="firstTap"
              data-bs-toggle="tab"
              data-bs-target="#firstTapcontent"
              type="button"
              role="tab"
              aria-controls="firstTapcontent"
              aria-selected="true"
            >
              {{ $t('managementOrders.new') }}
            </button>
          </li>
          <li class="nav-item" @click="getActiveOrders" role="presentation">
            <button
              class="nav-link"
              id="secondTap"
              data-bs-toggle="tab"
              data-bs-target="#secondTapcontent"
              type="button"
              role="tab"
              aria-controls="secondTapcontent"
              aria-selected="false"
            >
              {{ $t('managementOrders.current') }}
            </button>
          </li>
          <li class="nav-item" @click="getFinishedOrders" role="presentation">
            <button
              class="nav-link"
              id="thirdTap"
              data-bs-toggle="tab"
              data-bs-target="#thirdTapcontent"
              type="button"
              role="tab"
              aria-controls="thirdTapcontent"
              aria-selected="false"
            >
              {{ $t('managementOrders.finished') }}
            </button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <!--جديدة-->
          <div
            class="tab-pane fade show active"
            id="firstTapcontent"
            role="tabpanel"
            aria-labelledby="firstTapcontent-tab"
          >
            <dataTable
              :tableData="filteredNewOrders"
              :showLink="true"
              :HeadOfTable="HeadOfTable"
              linkDirection="orderDetails"
            />
          </div>
          <!--حالية-->
          <div
            class="tab-pane fade"
            id="secondTapcontent"
            role="tabpanel"
            aria-labelledby="secondTapcontent-tab"
          >
            <dataTable
              :tableData="filteredCurrentOrders"
              :showLink="true"
              :HeadOfTable="HeadOfTable"
              linkDirection="orderDetails"
            />
          </div>
          <!--منتهية-->
          <div
            class="tab-pane fade"
            id="thirdTapcontent"
            role="tabpanel"
            aria-labelledby="thirdTapcontent-tab"
          >
            <dataTable
              :tableData="filteredFinishedOrders"
              :showLink="true"
              :HeadOfTable="HeadOfTable"
              linkDirection="orderDetails"
            />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";
import dataTable from "../components/dashboard/dataTable.vue";
// import axios from "axios";
import { useI18n } from "vue-i18n";
import { ref, onMounted, computed } from "vue";
import { useStore } from 'vuex';

const { t } = useI18n();
const store = useStore();

// reactive state
const HeadOfTable = ref([
  {
    headText: t('managementOrders.serialNumber'),
    headKey: "id",
  },
  {
    headText: t('managementOrders.orderNumber'),
    headKey: "ref_code",
  },
  {
    headText: t('managementOrders.propertyType'),
    headKey: "type.name",
  },
  {
    headText: t('managementOrders.ownerName'),
    headKey: "owner.name",
  },
  {
    headText: t('managementOrders.phoneNumber'),
    headKey: "owner.phone",
  },
  {
    headText: t('managementOrders.orderDate'),
    headKey: "created_at",
  },
]);

// computed properties
const filteredNewOrders = computed(() => store.getters.filteredNewManagementOrders);
const filteredCurrentOrders = computed(() => store.getters.filteredActiveManagementOrders);
const filteredFinishedOrders = computed(() => store.getters.filteredFinishedManagementOrders);
// const loader = computed(() => store.getters.isLoading);
// const searchValue = computed(() => store.getters.searchValue);

// functions
const getNewOrders = () => {
  store.dispatch('fetchNewManagementOrders');
};

const getActiveOrders = () => {
  store.dispatch('fetchActiveManagementOrders');
};

const getFinishedOrders = () => {
  store.dispatch('fetchFinishedManagementOrders');
};

// lifecycle hooks
onMounted(() => {
  getNewOrders();
});
</script>
